import styled from 'styled-components';

export const DetailsContainer = styled.div`
  @media (max-width: 575px) {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a,
    span {
      color: var(--white);
    }
  }

  div:has(.button--link),
  div:has(.button--button) {
    width: 100%;
    .button--link,
    .button--button {
      width: 100%;
    }

    @media (max-width: 575px) {
      width: 100%;
      bottom: 0;
      left: 0;
      position: absolute;
      padding: 20px;
      background: var(--dark);
      margin: 0;
    }
  }
`;
